import uniq from 'lodash/uniq'
import { server } from '@/services'
import transformJson from '@/utils/transformJson'

const state = {
  isSearching: false,
  vehicle: [],
  licensePlates: [],
  servicingOverview: [],
  servicingOverviewFields: [],
  electricVehicles: []
}

const mutations = {
  SET_DATA: (state, payload) => {
    const keys = Object.keys(payload)
    keys.forEach((key) => {
      state[key] = payload[key]
    })
  },
  RESET_FORM: (state) => {
    state.vehicle = {}
  }
}

const actions = {
  fetchVehicle(_, { licensePlate, make, model }) {
    return server.get('/ops/getVehicleDataMR', { licensePlate, make, model })
  },
  updateVehicle(_, payload) {
    return server.post('/ops/upsertMRS_Vehicle', payload)
  },
  fetchLicensePlates ({ commit }, { query }) {
    return new Promise((resolve, reject) => {
      server.get(`/ops/getLicensePlates?licensePlate=${query}`).then(({ data }) => {
        let items = transformJson(data.msgContent.data, true).map(item => item.licensePlate)
        commit('SET_DATA', { licensePlates: uniq(items.sort((a, b) => a.localeCompare(b))) })
        resolve()
      }).catch((err) => reject(err))
    })
  },
  deleteInvoice(_, payload) {
    return server.delete(`/ops/deleteVehicleRecordMR/${payload.id}`)
  },
  getServicingOverview({ commit }) {
    return new Promise((resolve, reject) => {
      server.get('/ops/getServicingOverview').then(({ data }) => {
        const items = transformJson(data.msgContent.data, true)
        const fields = Object.keys(items[0]).map((k) => ({
          key: k,
          sortable: k !== 'followupRemarks',
        }))
        fields.unshift({ key: 'sn', sortable: false, width: 25 })
        
        commit('SET_DATA', { servicingOverview: items, servicingOverviewFields: fields })
        resolve()
      }).catch((err) => reject(err))
    })
  },
  getElectricVehicles({ commit }) {
    return new Promise((resolve, reject) => {
      server.post('/proxy/cocos/getEVs').then(({ data }) => {
        const items = transformJson(data.msgContent.data, true)
        resolve(items)
      })
    })
  },
  updateEvThreshold (_, payload) {
    return server.post('/proxy/cocos/updateEVBatteryLevelThreshold', payload)
  },
  getElectricVehicleConfig() {
    return new Promise((resolve) => {
      server.post('/proxy/cocos/getEVEmailReceivers').then(({ data }) => {
        const items = transformJson(data.msgContent.data, true)
        resolve(items)
      })
    })
  },
  upsertElectricVehicleConfig(_, payload) {
    return server.post('/proxy/cocos/upsertEVEmailReceiver', payload)
  },
  deleteElectricVehicleConfig(_, receiverId) {
    return server.post('/proxy/cocos/deleteEVEmailReceiver', { receiverId })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}